import { AccountType, AccountTypeSubset, UserDetails } from './Common';

export const accountsAccountType = [
	'handler',
	'management',
	'seniorManagement',
] as const;

export type AccountsAccountType = AccountType &
	(typeof accountsAccountType)[number];

export type UserInvitesAccountType = AccountTypeSubset<
	'handler' | 'seniorManagement'
>;

export type AccountsConfig = {
	titles: string[];
};

export const AccountsConfig: Record<AccountsAccountType, AccountsConfig> = {
	management: {
		titles: ['new accounts', 'users'],
	},
	handler: {
		titles: ['new accounts', 'users', 'invites'],
	},
	seniorManagement: {
		titles: ['new accounts', 'users', 'invites'],
	},
};

export const accountApprovalsMap: Record<AccountsAccountType, AccountType[]> = {
	handler: ['thirdPartyWorker', 'handler'],
	management: ['management', 'worker'],
	seniorManagement: ['seniorManagement', 'management', 'worker'],
};

export const accountUserInvitesMap: Record<
	UserInvitesAccountType,
	AccountType[]
> = {
	handler: ['thirdPartyWorker'],
	seniorManagement: ['worker'],
};

export type UserOptionsAccountUpdateFields = Pick<
	UserDetails,
	| 'site'
	| 'siteID'
	| 'siteCompany'
	| 'siteCompanyID'
	| 'contractedTo'
	| 'accountType'
	| 'disabledLeave'
	| 'disableTimesheetApproval'
>;
